/**
 * 重複要素を排除した配列を生成
 * @param arr1
 * @param arr2
 * @param key
 * @returns arr1 と arr2 の要素をマージして重複を排除した配列
 */
export const unionBy = <T, K extends keyof T>(
  arr1: T[],
  arr2: T[],
  key: K,
): T[] => {
  const mergedArray = [...arr1, ...arr2];

  return Array.from(
    mergedArray
      .reduce(
        (map, current) => map.set(current[key], current),
        new Map<T[K], T>(),
      )
      .values(),
  );
};
